import { Box } from "@bigcommerce/big-design";
import { theme } from "@bigcommerce/big-design-theme";
import styled from "styled-components";

export const StyledFixedBox = styled(Box)`
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: ${theme.zIndex.fixed};
    background-color: ${theme.colors.white};

  ${theme.breakpoints.desktop} {
    position: sticky;
    top: 128px;
    z-index: 99;
    background: white;
    padding: 10px;
    border-radius: 5px;
  }
   
`;